/**
 * PP Appearance: the PP readings QC has verified, read-only for the arrival desk.
 *
 * A static segment, so it takes precedence over `$form` (as `trading/` does).
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { PpAppearancePage } from "@/features/arrival/components/pp-appearance/pp-appearance-page";
import { useAuth } from "@/features/auth/store";

const search = z.object({
  srfNo: z.string().optional(),
  cropId: z.number().int().positive().optional(),
  varietyId: z.number().int().positive().optional(),
  lot: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1).catch(1),
});

export const Route = createFileRoute("/_app/arrivals/pp-appearance/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PpAppearancePage
      search={s}
      onSearch={(next) =>
        // Any change but the page's own starts again at page 1.
        void navigate({ search: (prev) => ({ ...prev, page: 1, ...next }) })
      }
    />
  );
}
